import { useQuery } from '@apollo/client'
import { searchInitiatives as searchGql } from 'src/graphql/queries/searchInitiatives.gql'

const useSearchInitiatives = (variables, options) => {
   const { data, error, ...otherQueryReturnValues } = useQuery(searchGql, {
      variables,
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      ...options
   })

   return {
      ...otherQueryReturnValues,
      error,
      searchInitiatives: data
         ? data.searchInitiatives
         : { items: [], listInfo: {} }
   }
}

export default useSearchInitiatives
